import { createSelector } from 'reselect';
import { get } from 'lodash/fp';
import { AuthState } from './authReducers';

// Define the shape of the global state (root state)
interface RootState {
    auth: AuthState;
}

export const authSelector = (state: RootState): AuthState => state.auth;

export const memberProfileSelector = createSelector(
    authSelector,
    (auth: AuthState) => auth.memberProfile,
);

export const isAuthenticatedSelector = createSelector(
    authSelector,
    (auth: AuthState): boolean => auth.isAuthenticated === true,
);

export const jwtSelector = createSelector(
    authSelector,
    (auth: AuthState) => (auth as any).jwt, // Cast to any if jwt isn't in your AuthState interface yet
);

export const memberIdSelector = createSelector(
    memberProfileSelector,
    (profile): string | undefined => get('Id', profile),
);
